import React from 'react';
import { IStatisticsPair, IParticipantsPair } from 'twain-sport-fe-mono/interfaces';
import { StatisticsValueType } from 'twain-sport-fe-mono/enums';
import { getAge } from 'twain-sport-fe-mono/utils';
import { Grid } from '../Grid';

interface IProps {
    participants: IParticipantsPair;
}

export const PlayersInfoGrid: React.FC<IProps> = (props) => {
    const participantsStatistic = React.useMemo(
        () =>
            Object.entries(props.participants).reduce((finalValue, [key, participant]) => {
                finalValue[key as keyof IStatisticsPair] = [
                    {
                        name: 'height',
                        value: participant.height,
                        type: StatisticsValueType.INT,
                    },
                    {
                        name: 'age',
                        value: getAge(participant.birthDate),
                        type: StatisticsValueType.INT,
                    },
                ];

                return finalValue;
            }, {} as IStatisticsPair),
        [props.participants],
    );

    return <Grid statistics={participantsStatistic} short />;
};
